import { render, staticRenderFns } from "./CardDadosDashboardMonitoramento.vue?vue&type=template&id=6b1c2894&scoped=true&lang=pug"
import script from "./CardDadosDashboardMonitoramento.vue?vue&type=script&lang=js"
export * from "./CardDadosDashboardMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./CardDadosDashboardMonitoramento.vue?vue&type=style&index=0&id=6b1c2894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c2894",
  null
  
)

export default component.exports